import { render, staticRenderFns } from "./SimuladorTabs.vue?vue&type=template&id=ddb0154c&scoped=true"
import script from "./SimuladorTabs.vue?vue&type=script&lang=js"
export * from "./SimuladorTabs.vue?vue&type=script&lang=js"
import style0 from "./SimuladorTabs.vue?vue&type=style&index=0&id=ddb0154c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0154c",
  null
  
)

export default component.exports